import { request } from '../utils/request';

const fetchApiPolicyDocs = () =>
  request.get('/api-policy-docs', { params: { type: 'json' } });

export default fetchApiPolicyDocs;
